function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaasBalance({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D9E5F8",
    style: {
      fill: "#D9E5F8",
      fill: "color(display-p3 0.8494 0.8973 0.9718)",
      fillOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.375 20.75C26.375 21.0467 26.287 21.3367 26.1222 21.5834C25.9574 21.83 25.7231 22.0223 25.449 22.1358C25.1749 22.2494 24.8733 22.2791 24.5824 22.2212C24.2914 22.1633 24.0241 22.0204 23.8143 21.8107C23.6046 21.6009 23.4617 21.3336 23.4038 21.0426C23.3459 20.7517 23.3756 20.4501 23.4892 20.176C23.6027 19.9019 23.795 19.6676 24.0416 19.5028C24.2883 19.338 24.5783 19.25 24.875 19.25C25.2728 19.25 25.6543 19.408 25.9356 19.6893C26.217 19.9706 26.375 20.3522 26.375 20.75ZM30.125 17.375V24.875C30.125 25.6706 29.8089 26.4337 29.2463 26.9963C28.6837 27.5589 27.9206 27.875 27.125 27.875H13.625C12.8293 27.875 12.0663 27.5589 11.5037 26.9963C10.9411 26.4337 10.625 25.6706 10.625 24.875V13.7113C10.6135 13.3101 10.6825 12.9107 10.8281 12.5367C10.9737 12.1627 11.1928 11.8217 11.4726 11.534C11.7523 11.2462 12.0869 11.0175 12.4567 10.8613C12.8264 10.7052 13.2237 10.6248 13.625 10.625H26C26.2984 10.625 26.5845 10.7435 26.7955 10.9545C27.0065 11.1655 27.125 11.4516 27.125 11.75C27.125 12.0484 27.0065 12.3345 26.7955 12.5455C26.5845 12.7565 26.2984 12.875 26 12.875H13.625C13.5244 12.8749 13.4249 12.8951 13.3322 12.9343C13.2396 12.9735 13.1558 13.031 13.0859 13.1032C13.0159 13.1755 12.9612 13.261 12.9249 13.3549C12.8887 13.4487 12.8717 13.5489 12.875 13.6494V13.6569C12.8907 13.8555 12.9819 14.0405 13.1297 14.174C13.2775 14.3075 13.4708 14.3795 13.67 14.375H27.125C27.9206 14.375 28.6837 14.6911 29.2463 15.2537C29.8089 15.8163 30.125 16.5794 30.125 17.375ZM27.875 17.375C27.875 17.1761 27.796 16.9853 27.6553 16.8447C27.5147 16.704 27.3239 16.625 27.125 16.625H13.67C13.4018 16.6251 13.1346 16.5911 12.875 16.5238V24.875C12.875 25.0739 12.954 25.2647 13.0947 25.4053C13.2353 25.546 13.4261 25.625 13.625 25.625H27.125C27.3239 25.625 27.5147 25.546 27.6553 25.4053C27.796 25.2647 27.875 25.0739 27.875 24.875V17.375Z",
    fill: "#3F7CDB",
    style: {
      fill: "#3F7CDB",
      fill: "color(display-p3 0.2471 0.4863 0.8588)",
      fillOpacity: 1
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaasBalance);
export default __webpack_public_path__ + "static/media/baas_balance.b8cd712a5070cf6aafd4ec9347e67c94.svg";
export { ForwardRef as ReactComponent };